import { DocumentViewer } from '@/attachment/component/DocumentViewer';

import {
  PolicySectionOverlay,
  SectionBoundingBox,
} from './PolicySectionOverlay';

interface PolicyDocumentViewerProps {
  blob: Blob;
  documentId: number;
  boundingBoxes: SectionBoundingBox[];
  onRectangleClick: (sectionUuid: string) => void;
  selectedSectionUuid: string | null;
  className?: string;
}

export const PolicyDocumentViewer = ({
  blob,
  documentId,
  boundingBoxes,
  onRectangleClick,
  selectedSectionUuid,
  className,
}: PolicyDocumentViewerProps) => (
  <DocumentViewer
    blob={blob}
    documentId={documentId}
    className={className}
    defaultNavigatorVisible={false}
    renderOverlay={(context) => (
      <PolicySectionOverlay
        {...context}
        boundingBoxes={boundingBoxes}
        onRectangleClick={onRectangleClick}
        selectedSectionUuid={selectedSectionUuid}
      />
    )}
  />
);
